import Form from "react-bootstrap/Form";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";

import LayerFour from "../assets/images/layers/Layer_4.png";

import bannerShape1 from "../assets/images/layers/banner_layer_one.png";
import bannerShape2 from "../assets/images/layers/banner_layer_two.png";
import sagarBabar from "../assets/images/Landing/sagar-babar.png";
import "../assets/css/AIFirstDeliveryCenter.css";
import AiCenter from "../assets/images/Landing/DataAndAIOffshoreDeliveryCenter.png";
import AiAcademy from "../assets/images/Landing/AiAcademy.png";
import AiProDev from "../assets/images/Landing/AiProdDev.png";
import onlineMeeting from "../assets/images/Landing/online-meeting.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import Logo from "../assets/images/black-logo.png";
import { CiMenuFries } from "react-icons/ci";
import Navbar from "react-bootstrap/Navbar";
import footerLogo from "../assets/images/dark-logo.png";
import fbook from "../assets/images/instagram.png";
import lkdin from "../assets/images/linkedin.png";
import ytube from "../assets/images/youtube.png";
import SalesforcePartnerBadge from "../assets/images/Salesforce_Partner_Badge.png";
import award from "../assets/images/Landing/award.png";
import twitter from "../assets/images/twitter.png";
import { submitLead } from "../leadService";


const GitexDubai = () => {

  const [show, setShow] = useState(false);

  const location = useLocation(); // Hook to get the current location

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Scroll to top whenever the location changes
    window.scrollTo(0, 0);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  const [showModal, setShowModal] = useState(false);
  // const handleOpenModal = () => setShowModal(true);
  // const handleCloseModal = () => setShowModal(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setIsSubmitted(false); // Reset the state when the modal closes
    setResponseMessage(""); // Also good practice to clear any messages
    setLoading(false); // Reset loading state
  };

  /*contact form*/
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
    role: "", // New role field
    subscribe: "yes", // New subscription field
    heardAbout: "",
    jobTitle: "",
    lastName: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  // Email validation regex (blocks free providers)
  const businessEmailRegex =
    /@(gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|aol\.com|icloud\.com|protonmail\.com|zoho\.com|mail\.com|gmx\.com)$/i;

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (isSubmitted) {
      const timer = setTimeout(() => {
        handleCloseModal();
      }, 60000);

      // Cleanup function to clear the timer if the component unmounts
      // or the state changes before the timer finishes
      return () => clearTimeout(timer);
    }
  }, [isSubmitted]); // The effect runs whenever isSubmitted changes

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    const { name, email, company, message } = formData;

    // Validate required fields
    if (!name || !email || !company || !message) {
      setResponseMessage("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    // Validate business email
    if (businessEmailRegex.test(email)) {
      setResponseMessage("Please enter a valid business email address.");
      setLoading(false);
      return;
    }


    try {
      const response = await submitLead("gitex-meeting", formData);
      if (response.success) {
        setResponseMessage("Form submitted successfully!");
        setIsSubmitted(true);
        // Clear the message after 3 seconds
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);

        // setFormData({ name: "", email: "", mobile: "", company: "", message: "" });
        setFormData({
          name: "",
          email: "",
          mobile: "",
          company: "",
          message: "",
        });
      } else {
        setResponseMessage(response.message);
      }
    } catch (error) {
      setResponseMessage("An error occurred. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        sticky="top"
        className={`navbar_menu ${scrolled ? "navbar-scrolled" : ""}`}
      >
        <Container>
          <Navbar.Brand href="/">
            <Image width={150} src={Logo} />
          </Navbar.Brand>
          {/* Mobile Offcanvas Toggle Button */}
          <div className="d-lg-none">
            <Button variant="light" onClick={handleShow}>
              <CiMenuFries />
            </Button>
          </div>
          {/* Desktop Menu */}
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="m-auto">
              <Nav.Link
                href="#AIOfferings"
                active={activeSection === "AIOfferings"}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("AIOfferings");
                  const section = document.getElementById("AIOfferings");
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                AI Offerings
              </Nav.Link>
            </Nav>
            <Nav>
              <div className="text-center">
                <Nav.Link
                  className="btn blue-btn"
                  as={Link}
                  to="/contact"
                  active={location.pathname === "/contact"}
                  style={{
                    background:
                      "linear-gradient(180deg, #067BB1 0%, #04467A 100%)",
                  }}
                >
                  Contact Us
                </Nav.Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Offcanvas */}
      <Offcanvas show={show} onHide={handleClose} className="d-lg-none">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link
              href="#AIOfferings"
              active={activeSection === "AIOfferings"}
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("AIOfferings");
                const section = document.getElementById("AIOfferings");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              AI Offerings
            </Nav.Link>
            <Nav.Link
              href="#FAQs"
              active={activeSection === "FAQs"}
              onClick={(e) => {
                e.preventDefault();
                setActiveSection("FAQs");
                const section = document.getElementById("FAQs");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              FAQs
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              active={location.pathname === "/contact"}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
      <header className="masthead z-0 pt-5 pb-5">
        <div className="container">
          <Image
            src={bannerShape1}
            className="z-n1 position-absolute top-0 end-0 opacity-25 w-40 d-none d-md-block"
          />
          <Row className="align-items-center justify-content-between">
            <Col lg="7">
              <div className="pe-3">
                <div>
                  <p className="text-black ls-minus-045 fw-700 fs-20 mb-2 mt-4">
                    Power Your Business with AI
                  </p>
                  <div className="text-left mb-4">
                    <Nav.Link
                      className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                      style={{ borderRadius: "10px" }}
                      onClick={handleOpenModal}
                    >
                      Book a meeting with us
                    </Nav.Link>
                  </div>
                </div>

                <div className="masthead-heading fw-800 text-black mb-2">
                  Your Strategic AI Partner{" "}
                </div>
                <div className="red-divider"></div>
                {/* <p className="text-black ls-minus-045 fw-800 fs-24 mb-1 mt-4">
                  Meet Us at GEC Dubai, 2025
                </p> */}
                <p className="mt-4 mb-4 lh-base">
                  Comsense Technologies specializes in Data and AI solutions
                  that enable organizations to fast-track their transformation
                  journeys. We help businesses build scalable AI capabilities,
                  transform ideas into intelligent, production-ready solutions
                  and foster enterprise-wide AI adoption.
                </p>
                <ul className="ps-3">
                  <li className="text-black fs-16 fw-700 mb-3">
                    40+ successful AI initiatives delivered
                  </li>
                  <li className="text-black fs-16 fw-700 mb-3">
                    30+ data scientists and AI engineers
                  </li>
                  <li className="text-black fs-16 fw-700 mb-3">
                    4 global locations
                  </li>
                  <li className="text-black fs-16 fw-700 mb-3">
                    Reusable IP & accelerators{" "}
                    <span className="fw-normal">
                      to develop products faster, and at a lower cost
                    </span>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="5" className="text-center">
              <Image
                src={sagarBabar}
                className="m-auto"
                style={{ width: "90%" }}
              />
            </Col>
          </Row>
          <Image
            src={bannerShape2}
            className="position-absolute bottom-0 end-0 w-40 d-none d-md-block bannerShapeBottom"
          />
        </div>
      </header>

      <section className="bg-E2F1FE pt-130 pb-80" id="AIOfferings">
        <Container>
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div className="text-center d-block d-md-flex align-items-center justify-content-center position-relative">
                <p className="bigBackFont">Solutions</p>
                <h2 className="section-heading section-heading-center fw-800 text-black subText1">
                  OUR AI OFFERINGS
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-5 justify-content-center align-items-center">
            <Col lg={4}>
              <Image src={AiCenter} className="w-100 pe-0 pe-lg-5" />
            </Col>
            <Col lg={7}>
              <div className="ps-0 ps-lg-5">
                <h2 className="text-black ls-minus-045 fw-800 fs-26 mb-4 mt-4">
                  Data & AI Offshore Delivery Center
                </h2>
                <p className="text-black ls-minus-045 fw-700 fs-20 mb-2 mt-4">
                  Build. Scale. Accelerate. Remotely.
                </p>
                <ul className="ps-3 red-bullets">
                  <li className="fs-14 mb-2">
                    Secure delivery teams with full IP protection
                  </li>
                  <li className="fs-14 mb-2">
                    Expertise across modern data platforms (Databricks,
                    Snowflake, Azure, GCP)
                  </li>
                  <li className="fs-14 mb-2">
                    End-to-end ML lifecycle with Python, MLOps, and automation
                  </li>
                  <li className="fs-14 mb-2">
                    Cost savings of up to <span className="fw-600">40%</span>{" "}
                    over in-house teams
                  </li>
                  <li className="fs-14 mb-2">
                    Rapid scale-up with{" "}
                    <span className="fw-600">25+ AI-ready resources </span>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="11" className="mt-2">
              <div className="rounded-blueTextBox mt-5">
                Ideal for enterprises and system integrators scaling their data
                and AI delivery without overhead
              </div>
            </Col>
          </Row>

          <Row className="mt-5 justify-content-center align-items-center">
            <Col lg={7}>
              <div className="pe-0 pe-lg-5">
                <h2 className="text-black ls-minus-045 fw-800 fs-26 mb-4 mt-4">
                  AI Product Development
                </h2>
                <p className="text-black ls-minus-045 fw-700 fs-20 mb-2 mt-4">
                  From Prototype to Production—Smarter, Faster.
                </p>
                <ul className="ps-3 red-bullets">
                  <li className="fs-14 mb-2">
                    Delivered{" "}
                    <span className="fw-600">
                      20+ enterprise-grade AI solutions
                    </span>{" "}
                    in NLP and GenAI
                  </li>
                  <li className="fs-14 mb-2">
                    Proven accelerators to cut time-to-market by up to{" "}
                    <span className="fw-600">60%</span>
                  </li>
                  <li className="fs-14 mb-2">
                    Modular architecture, scalable cloud-native deployment
                  </li>
                  <li className="fs-14 mb-2">
                    From idea to product within 6 to 8 weeks using our AI
                    accelerators
                  </li>
                  <li className="fs-14 mb-2">
                    End-to-end co-creation from PoC to MVP to full-scale product
                  </li>
                  <li className="fs-14 mb-2">
                    Integrated governance, security, and compliance
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4}>
              <Image src={AiProDev} className="w-100 ps-0 ps-lg-5" />
            </Col>

            <Col lg="11" className="mt-2 mb-4">
              <div className="rounded-blueTextBox mt-5">
                For innovation teams, digital labs and product companies needing
                fast and reliable AI buildouts
              </div>
            </Col>
          </Row>

          <Row className="mt-5 justify-content-center align-items-center">
            <Col lg={4}>
              <Image src={AiAcademy} className="w-100 pe-0 pe-lg-5" />
            </Col>
            <Col lg={7}>
              <div className="ps-0 ps-lg-5">
                <h2 className="text-black ls-minus-045 fw-800 fs-26 mb-4 mt-4">
                  AI Academy
                </h2>
                <p className="text-black ls-minus-045 fw-700 fs-20 mb-2 mt-4">
                  Train Talent. Transform Capability.
                </p>

                <ul className="ps-3 red-bullets">
                  <li className="fs-14 mb-2">
                    Delivered{" "}
                    <span className="fw-600">
                      10K+ hours enterprise-branded AI learning programs
                    </span>
                  </li>
                  <li className="fs-14 mb-2">
                    Structured journey:{" "}
                    <span className="fw-600">Beginner → Master</span>,
                    customized per client with real-world use cases, capstone
                    projects, and certifications
                  </li>
                  <li className="fs-14 mb-2">
                    Upskilled over <span className="fw-600">10,000+</span>{" "}
                    professionals across business and technical streams
                  </li>
                  <li className="fs-14 mb-2">
                    <span className="fw-600">100+ research / internship</span>{" "}
                    opportunities created
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="11" className="mt-2">
              <div className="rounded-blueTextBox mt-5">
                For enterprises investing in future-ready AI talent and internal
                transformation
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-4 pb-5 bg-white">
        <Container>
          {/* <Row className="align-items-center  justify-content-center testimonials-area position-relative">
            <Col lg="12" className="">
              <div className="rounded-blueTextBox rounded-blueTextBoxLg mt-5 position-relative">
                <h3 className="shadowText mb-4">
                  Visit Us at our Booth – Hall #26, NASSCOM Pavilion A50, Booth
                  #3
                </h3>
                <p className="text-white fw-500 fs-18 ps-5 pe-5">
                  Want to talk data, GenAI, or scalable engineering? Pre-book a
                  meeting with our experts or drop by to experience live demos
                  and success stories.
                </p>
                <Image src={cShape} className="cShape" />
              </div>
            </Col>
          </Row> */}
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div className="text-center mDiv d-flex align-items-center justify-content-start position-relative">
                <p
                  className="bigBackFont bigBackFont2 z-0"
                  style={{ color: "#f3f3fa" }}
                >
                  MEETING
                </p>
                <div className="d-flex imageText gap-4 text-left align-items-end z-1">
                  <Image src={onlineMeeting} style={{ width: "80px" }} />
                  <div>
                    <h2
                      className="mb-1 fw-800 text-black fs-4 text-left"
                      style={{ textAlign: "left" }}
                    >
                      Schedule a 1:1 Meeting with Our AI Experts
                    </h2>
                    <p
                      className="!text-left mb-0 fs-5 smallText fw-500"
                      style={{ textAlign: "left" }}
                    >
                      Lets turn your AI ambition into an action
                    </p>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <Nav.Link
                  className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  style={{ borderRadius: "10px" }}
                  onClick={handleOpenModal}
                >
                  Book a meeting with us
                </Nav.Link>
              </div>
              <Modal
                show={showModal}
                size="xl"
                onHide={handleCloseModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ overflow: "hidden" }}
              >
                <style>
                  {`.btn-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          z-index: 2;
        }
        .modal-content{overflow:hidden !important;}
        
        `}
                </style>
                <Modal.Header className="p-0" closeButton></Modal.Header>
                <Modal.Body className="p-0">
                  <div className="bg-E2F1FE position-relative box-shadow-one rounded-4 pt-5 p-23 p-sm-23">
                    <Image
                      src={LayerFour}
                      className="position-absolute bottom-0 start-0 w-40"
                    />

                    <Row className="position-relative form-box z-0">
                      {isSubmitted ? null : (
                        <Col lg={5}>
                          <div class="text-left d-flex  justify-content-start">
                            <h2 class="section-heading fw-700 fs-2">
                              Book Your Meeting With{" "}
                              <span className="text-ee0000">
                                Comsense Technologies
                              </span>
                              <span className="bordered-text bordered-text-start">
                                @ GITEX 2025
                              </span>
                            </h2>
                          </div>
                        </Col>
                      )}
                      <Col lg={isSubmitted ? 12 : 7}>
                        {isSubmitted ? (
                          <div className="text-center mt-5 mb-5">
                            <div class="text-center d-flex  justify-content-start">
                              <h2 class="section-heading m-auto fw-700 fs-2">
                                <span className="bordered-text bordered-text-start">
                                  Thank You !
                                </span>
                              </h2>
                            </div>
                            <p className="fs-4 fw-700 mt-4">
                              Look forward to meeting you at Hall #26, NASSCOM
                              Pavilion A50, Booth #3
                            </p>
                          </div>
                        ) : (
                          <Form onSubmit={handleSubmit}>
                            <Row className="pb-3 mt-3 mt-lg-0">
                              <Col lg={6}>
                                <>
                                  <Form.Label htmlFor="inputPassword5">
                                    Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                  />
                                </>
                              </Col>
                              <Col lg={6}>
                                <>
                                  <Form.Label>
                                    Business Email Address
                                  </Form.Label>
                                  <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                  />
                                </>
                              </Col>
                              <Col lg={6}>
                                <>
                                  <Form.Label htmlFor="CompanyName">
                                    Company Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                  />
                                </>
                              </Col>
                              <Col lg={12}>
                                <>
                                  <Form.Label htmlFor="Message">
                                    Message
                                  </Form.Label>
                                  <Form.Control
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    as="textarea"
                                    rows={4}
                                  />
                                </>
                              </Col>
                              <Col lg={12} className="mt-4 text-start">
                                <>
                                  {/* <a class="btn btn-danger btn-xl me-3 ls-0 fw-600" href="#">Submit</a> */}
                                  <Button
                                    variant=""
                                    type="submit"
                                    className="fw-600 d-block btn btn-danger btn-xl"
                                    disabled={loading}
                                  >
                                    {loading ? "Booking Now..." : "Book Now"}
                                  </Button>
                                </>
                              </Col>
                              {responseMessage && (
                                <p
                                  className="mt-3 mb-0 fs-12 text-center"
                                  style={{ color: loading ? "blue" : "red" }}
                                >
                                  {responseMessage}
                                </p>
                              )}
                            </Row>
                          </Form>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className="pt-50 bg-darkee footer-area pb-0"
        style={{
          background: "linear-gradient(180deg, #067BB1 -58.37%, #04467A 100%)",
        }}
      >
        <Container>
          <Row>
            <Col lg={4} md={4}>
              <Image src={footerLogo} className="fLogo mb-4" />
              <div className="footer-wrap">
                <ul className="d-flex gap-2">
                  {/* <li><a href=''><Image src={wapp}/></a></li> */}
                  <li>
                    <a
                      href="https://www.instagram.com/comsensemktg/#"
                      target="_blank" rel="noreferrer"
                    >
                      <Image src={fbook} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/comsense-consulting/"
                      target="_blank" rel="noreferrer"
                    >
                      <Image src={lkdin} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                      target="_blank" rel="noreferrer"
                    >
                      <Image src={ytube} />
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/ComsenseTech" target="_blank" rel="noreferrer">
                      <Image src={twitter} />
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4} md={4}>
              <div className="footer-wrap">
                <h5 className="fw-700 ls-0">Contact</h5>
                <p>
                  <span className="fw-600 ls-0">Email</span>:
                  connect@comsenseconsulting.com
                </p>
              </div>
            </Col>
            <Col xl={4} lg={4} md={12} sm={12}>
              <div className="footer-wrap text-start text-lg-end d-flex justify-content-md-end justify-content-lg-start align-items-end gap-4 align-items-center">
                <Image className="footer-salesforce-logo" src={award} />
                <Image
                  className="footer-salesforce-logo"
                  src={SalesforcePartnerBadge}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-5 justify-content-center">
            <Col lg={12} md={12}>
              <div className="copyright">
                <p>
                  Copyright {new Date().getFullYear()}  Comsense Technologies. All rights reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default GitexDubai;
